<template>
  <div class="pg-column-custom">
    <span v-if="showLabel">{{ text ?? '序号' }}</span>
    <i v-else class="ivu-icon-icon-pg-setting pg-column-custom__icon" @click="showDialogMethod"></i>
    <Dialog
      custom-class="pg-dialog pg-column-custom__dialog"
      top=""
      title="自定义列（勾选需要显示的列，拖动行进行排序）"
      modal
      append-to-body
      :visible="visible"
      width="1100px"
      @close="close"
      @open="open"
    >
      <div class="pg-column-custom__dialog-content">
        <PgTableDrag
          class="pg-column-custom__dialog-table"
          ref="pgTableRef"
          height="100%"
          columnTableCode="PG_CUSTOM_TABLE"
          :scrollBar="false"
          :rowConfig="{ height: 40 }"
          :scrollYConfig="{ enabled: false }"
          :seqShow="false"
          :loading="loading"
        >
        </PgTableDrag>
      </div>
      <template #footer>
        <Button type="danger" round @click="rest" :loading="restLoading">重置</Button>
        <Button type="primary" round @click="sure" :loading="sureLoading">保存</Button>
      </template>
    </Dialog>
  </div>
</template>
<script setup>
import { Dialog, Button } from 'element-ui'
import { ref, shallowRef, computed } from 'vue'
import { get, post } from '../../../utils/index'
import PgTableDrag from './table-drag.vue'
import { pgMessage } from '../../message'
import { pgMessageBoxAsync } from '../../message-box'

const props = defineProps({
  tableConfig: Object,
  text: String,
})

const emit = defineEmits(['on-ok'])

const showLabel = computed(
  () =>
    !props.tableConfig?.system?.id ||
    !props.tableConfig?.function?.id ||
    !props.tableConfig?.customize
)

const visible = ref(false)
const showDialogMethod = () => {
  visible.value = true
}
const close = () => {
  visible.value = false
}

const loading = ref(false)
const pgTableRef = ref(null)
const tableData = shallowRef(null)
const getData = async () => {
  loading.value = true
  const [res] = await get(`rest/ezcomp/dict/table/fetch/${props.tableConfig?.code}`)
  loading.value = false
  tableData.value = res?.data
  pgTableRef.value.loadData(tableData.value?.items)
}
const open = () => {
  getData()
}

const sureLoading = ref(false)
const sure = async () => {
  sureLoading.value = true
  const [res] = await post('rest/ezcomp/dict/table/saveTable', Object.assign({}, tableData.value))
  sureLoading.value = false
  if (res) {
    pgMessage.success('已保存')
    emit('on-ok')
    getData()
  }
  // visible.value = false
}

const restLoading = ref(false)
const rest = async () => {
  const { type, onClose } = await pgMessageBoxAsync({
    message: '确认重置?',
    cacelText: '取 消',
  })
  onClose()
  if (type !== 'confirm') return
  restLoading.value = true
  const [res] = await get('rest/ezcomp/dict/table/resetTable', {
    tableId: tableData.value.table.id,
  })
  restLoading.value = false
  if (res) {
    pgMessage.success('已重置')
    emit('on-ok')
    getData()
  }
}
</script>
<style lang="scss">
@import '../style/column-custom.scss';
</style>
